import classNames from 'classnames';
import { FC, useCallback, useContext } from 'react';
import { useIntl } from 'react-intl';
import { logAnalytics } from 'shared/middlewares/analytics/logger';
import { WorkspaceAnalyticCategoryContext } from 'shared/middlewares/analytics/loggerContext';

type DicardButtonProps = {
  className?: string;
  onDiscarded: () => void;
};
export const DiscardButton: FC<DicardButtonProps> = ({ className, onDiscarded }) => {
  const logAnalyticsCategory = useContext(WorkspaceAnalyticCategoryContext);
  const onClick = useCallback(() => {
    onDiscarded();
    logAnalytics.trackEvent(logAnalyticsCategory, 'Discard price improvement');
  }, [logAnalyticsCategory, onDiscarded]);

  const { formatMessage } = useIntl();

  return (
    <button
      className={classNames('btn btn-outline-primary border btn-lg my-0', className)}
      data-e2e="price-negotiation-discard-btn"
      onClick={onClick}
      type="button"
    >
      {formatMessage({ id: 'priceImprovement.discard.button.label' })}
    </button>
  );
};
